import { ReactNode } from "react"
import styled, { css } from "styled-components"

import { colors, spacing } from "@minuthq/meatball-ui-react"

export function Card({
  padding = spacing.M,
  backgroundColor = colors.neutralLight,
  boxShadow = true,
  border = false,
  children,
  ...props
}: {
  padding?: spacing | 0
  backgroundColor?: string
  boxShadow?: boolean
  border?: boolean
  children: ReactNode
}) {
  return (
    <Box
      $padding={padding}
      $backgroundColor={backgroundColor}
      $boxShadow={boxShadow}
      $border={border}
      {...props}
    >
      {children}
    </Box>
  )
}

const Box = styled.div<{
  $padding?: spacing | 0
  $boxShadow?: boolean
  $border?: boolean
  $backgroundColor: string
  $gap?: spacing
}>`
  overflow: hidden;
  padding: ${({ $padding }) => $padding};
  border-radius: 16px;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  border: ${({ $border }) =>
    $border ? `1px solid ${colors.divider};` : "unset"};
  ${({ $boxShadow }) => ($boxShadow ? boxshadow : undefined)};
`

const boxshadow = css`
  box-shadow:
    0px 0px 4px 0px rgba(18, 31, 65, 0.08),
    0px 8px 16px 0px rgba(18, 31, 65, 0.05);
`
